import { ReactNode } from 'react';

interface InnerPageWrapperProps {
    children: ReactNode;
}

const InnerPageWrapper = ({ children }: InnerPageWrapperProps) => {
    return (
        <div className="pt-4 md:pt-8 pb-10 md:pb-14 overflow-x-hidden">
            {children}
        </div>
    );
};

export default InnerPageWrapper;
